<template>
  <v-dialog scrollable max-width="800px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-btn small text v-on="on" @click="cargar">
          <v-icon left>search</v-icon>
          Estados
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h4>Estados macheo</h4>
      </v-card-title>
      <v-card-text>
        <template v-if="estados.length > 0">
          <v-data-table
            single-select
            :headers="headers"
            :items-per-page="10"
            :items="estados"
            class="elevation-1"
          >
          </v-data-table>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  props: ["id", "cedula", "grupoMacheoId"],
  data() {
    return {
      loading: false,
      showDialog: false,
      estados: [],
      headers: [
        {
          text: "Origen",
          align: "start",
          sortable: false,
          value: "origen",
        },
        { text: "Usuario", sortable: false, value: "usuario" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Cantidad", sortable: false, align: "end", value: "cantidad" },
      ],
    };
  },
  mounted() {},
  methods: {
    volver() {
      this.showDialog = false;
    },
    cargar() {

      const params = {grupoMacheoId: this.grupoMacheoId};

      axios
        .get("/macheo/getEstadosMacheo", {params})
        .then((res) => {
          this.estados = res.data;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
  },
});
</script>
